import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelInput from 'components/common/LabelInput';
import LabelSelectButton from 'components/common/LabelSelectButton';
import {allowStateOption, dataOffsetOption} from 'data/option';
import {allowStateStatus} from 'data/status';
import {
  activateRerralCode,
  changeAllowStateBackOffice,
  changeAllowStateBackOfficeRequestApproval,
  discardRerralCode,
  registerReferralCode,
  updateRerralCode,
} from 'function/api';
import {IPermissionState} from 'interfaces/interface';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';
import {useFormatMsg} from 'utils/useFormatMsg';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};
const DiscardCodeModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);
  const [completeModal, setCompleteModal] = useState(false);

  useEffect(() => {
    return () => {
      setCompleteModal(false);
    };
  }, []);
  return (
    <>
      <CommonModal closeModal={closeModal}>
        <BusinessModalContainer>
          <BusinessModalHeader>
            <DefaultText
              text={'추천 코드 삭제'}
              textStyle={{
                fontSize: minmax(40),
              }}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </BusinessModalHeader>

          <DefaultText
            text={'추천 코드를 삭제하시겠습니까?'}
            textStyle={{fontSize: minmax(30), marginBottom: minmax(30)}}
          />

          <DefaultButton
            text={'삭제하기'}
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: colors.primary2,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={async () => {
              //

              let result;

              const isDiscarded = selectItem?.referralCode?.isDiscarded;

              if (isDiscarded) {
                result = await activateRerralCode({
                  userInfo,
                  setIsLoading,
                  setErrorModal,
                  referralCodeUUID: selectItem?.referralCode?.uuid,
                });
              } else {
                result = await discardRerralCode({
                  userInfo,
                  setIsLoading,
                  setErrorModal,
                  referralCodeUUID: selectItem?.referralCode?.uuid,
                });
              }

              if (result) setCompleteModal(true);
            }}
          />
        </BusinessModalContainer>
      </CommonModal>
      {completeModal && (
        <CommonModal
          title={'삭제 완료!'}
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default DiscardCodeModal;

const BusinessModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const BusinessModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;
